module.exports = __webpack_public_path__ + "static/home-game-1606c0e1ad970ac23099b729bdfbc3e4.jpg";